// ブランドメニュー 遷移先を在庫ありの状態にする
document.addEventListener('DOMContentLoaded', function() {
  const stockParam = 'pf_st_zai_ku_zhuang_kuang=in-stock';

  const updateDrawerLinks = () => {
    // ドロワー内の全リンクを取得
    const drawerLinks = document.querySelectorAll('.drawer__content a[href*="/collections/"]');
    drawerLinks.forEach(link => {
      let href = link.getAttribute('href');
      // パラメーターが未付与の場合のみ処理
      if (href && !href.includes(stockParam)) {
        const joiner = href.includes('?') ? '&' : '?';
        link.setAttribute('href', href + joiner + stockParam);
      }
    });
  };

  // 1. ページロード時に実行
  updateDrawerLinks();

  // 2. メニューが開くボタンが押された時（動的生成対策）
  document.querySelectorAll('[aria-controls="mobile-menu-drawer"], .tap-area').forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(updateDrawerLinks, 300); // 描画待ち
    });
  });
});


// 各トップページのカテゴリリスト 遷移先を在庫ありの状態にする
document.addEventListener('DOMContentLoaded', function() {
  // 共通のクラス名「.c_category-lists」を基準に対象を探す
  const categorySections = document.querySelectorAll('.c_category-lists');

  categorySections.forEach(section => {
    const stockParam = 'pf_st_zai_ku_zhuang_kuang=in-stock';

    // --- 在庫パラメーターを全てのリンクに付与する関数 ---
    function applyStockParam() {
      const links = section.querySelectorAll('a[href*="/collections/"]');
      links.forEach(link => {
        let href = link.getAttribute('href');
        if (href && !href.includes(stockParam)) {
          const joiner = href.includes('?') ? '&' : '?';
          link.setAttribute('href', href + joiner + stockParam);
        }
      });
    }

    // 初回実行
    applyStockParam();

    // --- タブ切り替えロジック ---
    const filterButtons = section.querySelectorAll('.tag-button[data-category-id]');
    const articleWrappers = section.querySelectorAll('.c_category-lists__articles[data-category-id]');

    function showArticlesByBlockId(blockId) {
      articleWrappers.forEach(wrapper => {
        const wrapperId = wrapper.getAttribute('data-category-id');
        wrapper.style.display = (wrapperId === blockId) ? 'grid' : 'none';
      });
      // タブを切り替えた直後にもう一度パラメーター適用を確認
      applyStockParam();
    }

    filterButtons.forEach(button => {
      button.addEventListener('click', function() {
        filterButtons.forEach(btn => btn.classList.remove('is-active'));
        this.classList.add('is-active');

        const blockId = this.getAttribute('data-category-id');
        showArticlesByBlockId(blockId);
      });
    });
  });
});